import React, { Component } from 'react';
import * as LEGAL from '../LegalCopy'

const Header = () => {
  return (
    <div>
      <div className="legalHeader">{LEGAL.HEADER}</div>
      <div className="legalBodySection">{LEGAL.INTRODUCTION}{'\n'}</div>
    </div>
  );
};
const Content = () => {
  return (
    <div>
      <div>
        <div className="legalHeader">{LEGAL.SCOPE_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.SCOPE}</div>
      </div>
      <div>
        <div className="legalHeader">{LEGAL.ELIGIBILITY_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.ELIGIBILITY}</div>
      </div>
      <div>
        <div className="legalHeader">{LEGAL.CONTENT_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.CONTENT}</div>
      </div>
      <div>
        <div className="legalHeader">{LEGAL.YOUR_CONDUCT_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.YOUR_CONDUCT}</div>
        <div className="legalBodyCopy">{LEGAL.YOUR_CONDUCT_1}</div>
        <div className="legalBodyCopy">{LEGAL.YOUR_CONDUCT_2}</div>
        <div className="legalBodyCopy">{LEGAL.YOUR_CONDUCT_3}</div>
        <div className="legalBodyCopy">{LEGAL.YOUR_CONDUCT_4}</div>
        <div className="legalBodyCopy">{LEGAL.YOUR_CONDUCT_5}</div>
        <div className="legalBodyCopy">{LEGAL.YOUR_CONDUCT_5}</div>
        
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES}</div>
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES_1}</div>
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES_2}</div>
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES_3}</div>
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES_4}</div>
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES_5}</div>
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES_6}</div>
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES_7}</div>
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES_8}</div>
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES_9}</div>
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES_10}</div>
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES_11}</div>
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES_12}</div>
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES_13}</div>
        <div className="legalBodyCopy">{LEGAL.PROHIBITED_USES_14}</div>

        <div className="legalHeader">{LEGAL.WELLBEING_PORTAL_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.WELLBEING_PORTAL_1}</div>
        <div className="legalBodyCopy">{LEGAL.WELLBEING_PORTAL_2}</div>
        <div className="legalBodyCopy">{LEGAL.WELLBEING_PORTAL_3}</div>
        <div className="legalBodyCopy">{LEGAL.WELLBEING_PORTAL_4}</div>
        <div className="legalBodyCopy">{LEGAL.WELLBEING_PORTAL_1}</div>

        <div className="legalHeader">{LEGAL.LINKED_SITES_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.LINKED_SITES}</div>

        <div className="legalHeader">{LEGAL.COPYRIGHT_TRADEMARKS_IP_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.COPYRIGHT_TRADEMARKS_IP}</div>
        <div className="legalBodyCopy">{LEGAL.COPYRIGHT_TRADEMARKS_IP_1}</div>

        <div className="legalHeader">{LEGAL.DISCLAIMER_OF_WARRANTIES_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.DISCLAIMER_OF_WARRANTIES}</div>
        <div className="legalBodyCopy">{LEGAL.DISCLAIMER_OF_WARRANTIES_1}</div>
        <div className="legalBodyCopy">{LEGAL.DISCLAIMER_OF_WARRANTIES_2}</div>
        <div className="legalBodyCopy">{LEGAL.DISCLAIMER_OF_WARRANTIES_3}</div>
        <div className="legalBodyCopy">{LEGAL.DISCLAIMER_OF_WARRANTIES_4}</div>
        <div className="legalBodyCopy">{LEGAL.DISCLAIMER_OF_WARRANTIES_5}</div>
        <div className="legalBodyCopy">{LEGAL.DISCLAIMER_OF_WARRANTIES_6}</div>
        <div className="legalBodyCopy">{LEGAL.DISCLAIMER_OF_WARRANTIES_7}</div>

        <div className="legalHeader">{LEGAL.LIMITATION_OF_LIABILITY_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.LIMITATION_OF_LIABILITY}</div>
        <div className="legalBodyCopy">{LEGAL.LIMITATION_OF_LIABILITY_1}</div>

        <div className="legalHeader">{LEGAL.INDEMNIFICATION_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.INDEMNIFICATION}</div>

        <div className="legalHeader">{LEGAL.TERMINATION_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.TERMINATION}</div>

        <div className="legalHeader">{LEGAL.AVAILABILITY_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.AVAILABILITY}</div>

        <div className="legalHeader">{LEGAL.RIGHT_TO_CHANGE_TERMS_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.RIGHT_TO_CHANGE_TERMS}</div>

        <div className="legalHeader">{LEGAL.NO_GUARANTEE_OF_EMPLOYMENT_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.NO_GUARANTEE_OF_EMPLOYMENT}</div>

        <div className="legalHeader">{LEGAL.EEOC_STATEMENT_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.EEOC_STATEMENT}</div>

        <div className="legalHeader">{LEGAL.SEVERABILITY_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.SEVERABILITY}</div>

        <div className="legalHeader">{LEGAL.APPLICABLE_LAW_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.APPLICABLE_LAW}</div>

        <div className="legalHeader">{LEGAL.PRIVACY_POLICY_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.PRIVACY_POLICY}</div>

        <div className="legalHeader">{LEGAL.GENERAL_TERMS_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.GENERAL_TERMS}</div>

        <div className="legalHeader">{LEGAL.CONTACTING_US_HEADER}</div>
        <div className="legalBodyCopy">{LEGAL.CONTACTING_US}</div>
      </div>

    </div>

  );
}




export default class LegalWaiver extends Component {
  render() {
    return (
      <div>
        <Header />
        <Content />
      </div>
    );
  }
}
